/**
 * @file Nav Trigger.
 */

/**
 * Nav Trigger component.
 */
const vNavTrigger = () => {
	const navTriggers = document.querySelectorAll('.v-nav-trigger');

	if (!navTriggers || !navTriggers.length) {
		return;
	}

	const query = window.matchMedia('(min-width: 1024px)');
	const body = document.querySelector('body');
	let isOpen = body.classList.contains('menu-open');

	[...navTriggers].forEach((navTrigger) => {
		navTrigger.addEventListener('click', (e) => {
			e.preventDefault();
			if (query.matches) {
				return;
			}

			isOpen = !isOpen;
			const event = new CustomEvent('vNavTrigger', {
				detail: {
					isOpen,
				},
			});

			document.dispatchEvent(event);
		});
	});
};

export default vNavTrigger;
